import { Card, Divider, Typography } from '@material-ui/core'
import React, { useRef, } from 'react';
import { useStyles } from '../style'
import '../style.css'

function GroupInfo() {
    const classes = useStyles()
    const chatBodyRef = useRef(null)


    return (
        <div>
            <Typography>gjjg</Typography>
        </div>
    )
}

export default GroupInfo